module.exports = __webpack_public_path__ + "static/media/Service.0f607a7b.svg";